import { loadScriptByCode } from '@src/utils';

export const loadMetrikaScript = (id: string) => {
  const code =
    '(function(m,e,t,r,i,k,a){' +
    'm[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};' +
    'm[i].l=1*new Date();' +
    'for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}' +
    'k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)' +
    `})(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${id}', 'ym');`;

  loadScriptByCode(code);
};

export const initMetrika = (id: string) => {
  const initConfig = {
    triggerEvent: true,
    ssr: true,
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  };

  const code = `ym(${id}, 'init', ${JSON.stringify(initConfig)});`;

  loadScriptByCode(code);
};
export const checkMetrika = (id: string) => {
  const url = window.location.href;
  const code = `ym(${id}, 'hit', '${url}');`;
  loadScriptByCode(code);
};
